// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3YkXt","header":"MessagesList_header__1L-Tr","chat":"MessagesList_chat__z-Oaa"};